import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Подпись места, запертого идущей проверкой курса (`useIsCourseFrozen`). Общая
 * для всех текстовых локов: `useIsCourseTextLocked` истинен И на переводе, И на
 * проверке, и место обязано назвать настоящую причину, а не «идёт перевод».
 */
export const reviewLockText = (): string => messagesNow(messages).reviewLock

/** Отказ хендлера записи состава курса (урок добавить/удалить/переставить),
 *  когда кнопку нажали за миг до того, как опрос принёс `pending`. */
export const reviewChangeRefused = (): string => messagesNow(messages).reviewChangeRefused

/** Отказ фонового коммита загруженной картинки (блок, курс, урок, маскот). */
export const reviewUploadRefused = (): string => messagesNow(messages).reviewUploadRefused

/** Отказ пакетной записи (реордер экранов, оформление урока), пока студия переезжает на
 *  только что заведённый черновик живого курса (`useIsDraftSourceSettling`). */
export const draftSettlingRefused = (): string => messagesNow(messages).draftSettlingRefused

// Русские константы — для потребителей, ещё не перешедших на функции выше
// (они читают язык в момент вызова). Новый код зовёт функции.
export const REVIEW_LOCK_TEXT = messages.ru.reviewLock
export const REVIEW_CHANGE_REFUSED = messages.ru.reviewChangeRefused
export const REVIEW_UPLOAD_REFUSED = messages.ru.reviewUploadRefused
export const DRAFT_SETTLING_REFUSED = messages.ru.draftSettlingRefused
